import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp40};
  margin-top: ${props => props.theme.spacing.sp32};
  align-items: center;
`

export const PieSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const LabelsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp24};
`
